import { FC } from 'react'
import styled from 'styled-components'
import { Text } from 'ui'
import { Vicon } from '../icons'

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    height: 100%;
    min-height: 360px;
    text-align: center;
    padding: 0 16px;
`

const IconWrapper = styled.div`
    transform: scale(2.5);
    margin-bottom: 24px;
`

// Shown once a coupon was sent. Publishing is no longer paid up front — the coupon lands
// in the admin approval queue and the Mekomi team contacts the publisher.
const Step5: FC = () => {
    return (
        <Container>
            <IconWrapper>
                <Vicon />
            </IconWrapper>
            <Text size="lg" weight="bold" style={{ color: '#272727' }}>
                תודה על הפרסום
            </Text>
            <Text size="md" weight="normal" style={{ color: '#5D5D5D' }}>
                צוות מקומי יבדוק אותו ויצור איתך קשר בהקדם.
            </Text>
        </Container>
    )
}

export default Step5
